module.exports = __webpack_public_path__ + "static/img_2609-e51c74b6d5dfe27f5b1a7429a1010916.webp";